/*
 * Two letters at most, from the first two words of a name.
 *
 * Decorative in every caller: the name itself is rendered beside the disc and the disc is
 * `aria-hidden`, so no screen reader is made to spell out "C C". Lifted here once the third caller
 * appeared (RES-1387's conversation rows) — three byte-identical copies is how one of them silently
 * stops matching the others.
 */
export const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0])
    .join('')
    .toUpperCase();
